import { useEffect, useRef } from 'react'
import { subscribeFrame } from '@/lib/frame'

export const useScrollFrame = (callback: () => void, enabled = true): void => {
    const saved = useRef(callback)

    useEffect(() => {
        saved.current = callback
    })

    useEffect(() => {
        if (!enabled) return

        return subscribeFrame(() => saved.current())
    }, [enabled])
}
